import React, { useState, useEffect } from "react";
import {
  Card,
  Col,
  Button,
  Form,
  Row,
  Breadcrumb,
  Modal,
  Table,
} from "react-bootstrap";
import FalconCloseButton from "components/common/falconCloseButton";
import { useTranslation } from "react-i18next";
import TemplateRenderer from "../proposalTemplates/templateRenderer";

const ProposalModal = ({
  show,
  handleClose,
  selectedTemplate,
  formData
}) => {
  const { t } = useTranslation();
  
  const templateTitles = {
    WindowCleaning: t("windowCleaning"),
    FloorMaintenance: t("floorMaintenance"),
    RegularCleaning: t("regularCleaning"),
  };
  return (
    <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
      <Modal.Header>
        <Modal.Title>
          { selectedTemplate}
        </Modal.Title>
        <FalconCloseButton onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <TemplateRenderer
          formData={formData}
          workType={selectedTemplate}
          logoSrc={formData.logoSrc}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ProposalModal;
